import { InjectionToken } from '@angular/core';
import { Language, SOFTLINE_LANGUAGE_DE } from './languages';

export const SOFTLINE_FEATURE_LANGUAGE = "language";

export const SOFTLINE_CONFIG_LANGUAGES = new InjectionToken<Language[]>("SOFTLINE_CONFIG_LANGUAGES",
  { providedIn: 'root', factory: () => [SOFTLINE_LANGUAGE_DE] }
);
